import { render, staticRenderFns } from "./CheckoutListTemplate.vue?vue&type=template&id=065d2256"
import script from "./CheckoutListTemplate.vue?vue&type=script&lang=js"
export * from "./CheckoutListTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports